import { UrlConstants } from "../url.constants";
export class ApiStepMetaConstants {
    static URL = UrlConstants.API_V2 + "StepMeta";
    static FUNCTION_GET_STEP_META_CONFIGURATION = "GetStepMetaConfiguration";
    static FUNCTION_VALIDATE_STEP_META_JSON_SCHEMA = "ValidateStepMetaJsonSchema";
    static FUNCTION_EXPORT_METADATA = "ExportMetadata";
    static FUNCTION_IMPORT_METADATA = "ImportMetadata";
}
